/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UserManagementIndexRouteImport } from './routes/user-management/index'
import { Route as SoaIndexRouteImport } from './routes/soa/index'
import { Route as RiskIndexRouteImport } from './routes/risk/index'
import { Route as ResetPasswordIndexRouteImport } from './routes/reset-password/index'
import { Route as ReportsIndexRouteImport } from './routes/reports/index'
import { Route as RegisterIndexRouteImport } from './routes/register/index'
import { Route as RaciIndexRouteImport } from './routes/raci/index'
import { Route as ProfileIndexRouteImport } from './routes/profile/index'
import { Route as PlatformAdminIndexRouteImport } from './routes/platform-admin/index'
import { Route as NonInfosecRiskIndexRouteImport } from './routes/non-infosec-risk/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as GuideIndexRouteImport } from './routes/guide/index'
import { Route as ForgotPasswordIndexRouteImport } from './routes/forgot-password/index'
import { Route as AssetsIndexRouteImport } from './routes/assets/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AcceptInviteIndexRouteImport } from './routes/accept-invite/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UserManagementIndexRoute = UserManagementIndexRouteImport.update({
  id: '/user-management/',
  path: '/user-management/',
  getParentRoute: () => rootRouteImport,
} as any)
const SoaIndexRoute = SoaIndexRouteImport.update({
  id: '/soa/',
  path: '/soa/',
  getParentRoute: () => rootRouteImport,
} as any)
const RiskIndexRoute = RiskIndexRouteImport.update({
  id: '/risk/',
  path: '/risk/',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordIndexRoute = ResetPasswordIndexRouteImport.update({
  id: '/reset-password/',
  path: '/reset-password/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsIndexRoute = ReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterIndexRoute = RegisterIndexRouteImport.update({
  id: '/register/',
  path: '/register/',
  getParentRoute: () => rootRouteImport,
} as any)
const RaciIndexRoute = RaciIndexRouteImport.update({
  id: '/raci/',
  path: '/raci/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileIndexRoute = ProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformAdminIndexRoute = PlatformAdminIndexRouteImport.update({
  id: '/platform-admin/',
  path: '/platform-admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const NonInfosecRiskIndexRoute = NonInfosecRiskIndexRouteImport.update({
  id: '/non-infosec-risk/',
  path: '/non-infosec-risk/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const GuideIndexRoute = GuideIndexRouteImport.update({
  id: '/guide/',
  path: '/guide/',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordIndexRoute = ForgotPasswordIndexRouteImport.update({
  id: '/forgot-password/',
  path: '/forgot-password/',
  getParentRoute: () => rootRouteImport,
} as any)
const AssetsIndexRoute = AssetsIndexRouteImport.update({
  id: '/assets/',
  path: '/assets/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInviteIndexRoute = AcceptInviteIndexRouteImport.update({
  id: '/accept-invite/',
  path: '/accept-invite/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accept-invite/': typeof AcceptInviteIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/assets/': typeof AssetsIndexRoute
  '/forgot-password/': typeof ForgotPasswordIndexRoute
  '/guide/': typeof GuideIndexRoute
  '/login/': typeof LoginIndexRoute
  '/non-infosec-risk/': typeof NonInfosecRiskIndexRoute
  '/platform-admin/': typeof PlatformAdminIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/raci/': typeof RaciIndexRoute
  '/register/': typeof RegisterIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/reset-password/': typeof ResetPasswordIndexRoute
  '/risk/': typeof RiskIndexRoute
  '/soa/': typeof SoaIndexRoute
  '/user-management/': typeof UserManagementIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteIndexRoute
  '/admin': typeof AdminIndexRoute
  '/assets': typeof AssetsIndexRoute
  '/forgot-password': typeof ForgotPasswordIndexRoute
  '/guide': typeof GuideIndexRoute
  '/login': typeof LoginIndexRoute
  '/non-infosec-risk': typeof NonInfosecRiskIndexRoute
  '/platform-admin': typeof PlatformAdminIndexRoute
  '/profile': typeof ProfileIndexRoute
  '/raci': typeof RaciIndexRoute
  '/register': typeof RegisterIndexRoute
  '/reports': typeof ReportsIndexRoute
  '/reset-password': typeof ResetPasswordIndexRoute
  '/risk': typeof RiskIndexRoute
  '/soa': typeof SoaIndexRoute
  '/user-management': typeof UserManagementIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/accept-invite/': typeof AcceptInviteIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/assets/': typeof AssetsIndexRoute
  '/forgot-password/': typeof ForgotPasswordIndexRoute
  '/guide/': typeof GuideIndexRoute
  '/login/': typeof LoginIndexRoute
  '/non-infosec-risk/': typeof NonInfosecRiskIndexRoute
  '/platform-admin/': typeof PlatformAdminIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/raci/': typeof RaciIndexRoute
  '/register/': typeof RegisterIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/reset-password/': typeof ResetPasswordIndexRoute
  '/risk/': typeof RiskIndexRoute
  '/soa/': typeof SoaIndexRoute
  '/user-management/': typeof UserManagementIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-invite/'
    | '/admin/'
    | '/assets/'
    | '/forgot-password/'
    | '/guide/'
    | '/login/'
    | '/non-infosec-risk/'
    | '/platform-admin/'
    | '/profile/'
    | '/raci/'
    | '/register/'
    | '/reports/'
    | '/reset-password/'
    | '/risk/'
    | '/soa/'
    | '/user-management/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accept-invite'
    | '/admin'
    | '/assets'
    | '/forgot-password'
    | '/guide'
    | '/login'
    | '/non-infosec-risk'
    | '/platform-admin'
    | '/profile'
    | '/raci'
    | '/register'
    | '/reports'
    | '/reset-password'
    | '/risk'
    | '/soa'
    | '/user-management'
  id:
    | '__root__'
    | '/'
    | '/accept-invite/'
    | '/admin/'
    | '/assets/'
    | '/forgot-password/'
    | '/guide/'
    | '/login/'
    | '/non-infosec-risk/'
    | '/platform-admin/'
    | '/profile/'
    | '/raci/'
    | '/register/'
    | '/reports/'
    | '/reset-password/'
    | '/risk/'
    | '/soa/'
    | '/user-management/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AcceptInviteIndexRoute: typeof AcceptInviteIndexRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AssetsIndexRoute: typeof AssetsIndexRoute
  ForgotPasswordIndexRoute: typeof ForgotPasswordIndexRoute
  GuideIndexRoute: typeof GuideIndexRoute
  LoginIndexRoute: typeof LoginIndexRoute
  NonInfosecRiskIndexRoute: typeof NonInfosecRiskIndexRoute
  PlatformAdminIndexRoute: typeof PlatformAdminIndexRoute
  ProfileIndexRoute: typeof ProfileIndexRoute
  RaciIndexRoute: typeof RaciIndexRoute
  RegisterIndexRoute: typeof RegisterIndexRoute
  ReportsIndexRoute: typeof ReportsIndexRoute
  ResetPasswordIndexRoute: typeof ResetPasswordIndexRoute
  RiskIndexRoute: typeof RiskIndexRoute
  SoaIndexRoute: typeof SoaIndexRoute
  UserManagementIndexRoute: typeof UserManagementIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user-management/': {
      id: '/user-management/'
      path: '/user-management'
      fullPath: '/user-management/'
      preLoaderRoute: typeof UserManagementIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/soa/': {
      id: '/soa/'
      path: '/soa'
      fullPath: '/soa/'
      preLoaderRoute: typeof SoaIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/risk/': {
      id: '/risk/'
      path: '/risk'
      fullPath: '/risk/'
      preLoaderRoute: typeof RiskIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password/': {
      id: '/reset-password/'
      path: '/reset-password'
      fullPath: '/reset-password/'
      preLoaderRoute: typeof ResetPasswordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/': {
      id: '/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof ReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register/': {
      id: '/register/'
      path: '/register'
      fullPath: '/register/'
      preLoaderRoute: typeof RegisterIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/raci/': {
      id: '/raci/'
      path: '/raci'
      fullPath: '/raci/'
      preLoaderRoute: typeof RaciIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/': {
      id: '/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof ProfileIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform-admin/': {
      id: '/platform-admin/'
      path: '/platform-admin'
      fullPath: '/platform-admin/'
      preLoaderRoute: typeof PlatformAdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/non-infosec-risk/': {
      id: '/non-infosec-risk/'
      path: '/non-infosec-risk'
      fullPath: '/non-infosec-risk/'
      preLoaderRoute: typeof NonInfosecRiskIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guide/': {
      id: '/guide/'
      path: '/guide'
      fullPath: '/guide/'
      preLoaderRoute: typeof GuideIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password/': {
      id: '/forgot-password/'
      path: '/forgot-password'
      fullPath: '/forgot-password/'
      preLoaderRoute: typeof ForgotPasswordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assets/': {
      id: '/assets/'
      path: '/assets'
      fullPath: '/assets/'
      preLoaderRoute: typeof AssetsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invite/': {
      id: '/accept-invite/'
      path: '/accept-invite'
      fullPath: '/accept-invite/'
      preLoaderRoute: typeof AcceptInviteIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AcceptInviteIndexRoute: AcceptInviteIndexRoute,
  AdminIndexRoute: AdminIndexRoute,
  AssetsIndexRoute: AssetsIndexRoute,
  ForgotPasswordIndexRoute: ForgotPasswordIndexRoute,
  GuideIndexRoute: GuideIndexRoute,
  LoginIndexRoute: LoginIndexRoute,
  NonInfosecRiskIndexRoute: NonInfosecRiskIndexRoute,
  PlatformAdminIndexRoute: PlatformAdminIndexRoute,
  ProfileIndexRoute: ProfileIndexRoute,
  RaciIndexRoute: RaciIndexRoute,
  RegisterIndexRoute: RegisterIndexRoute,
  ReportsIndexRoute: ReportsIndexRoute,
  ResetPasswordIndexRoute: ResetPasswordIndexRoute,
  RiskIndexRoute: RiskIndexRoute,
  SoaIndexRoute: SoaIndexRoute,
  UserManagementIndexRoute: UserManagementIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
